<ng-container *ngIf="isShowAll;else inputMode">

    <div [ngStyle]="getStylesObject()">

        <div id="map_Container" class="w-100 h-100"> </div>

    </div>

</ng-container>

<ng-template #inputMode>

    <div *ngIf="!isOpenModal" [formGroup]="mdl_Map" class="map-container">

        <!-- "TEXTAREA" انتخاب حالت دریافت آدرس -->

        <ng-container *ngIf="isTextArea;else isInput">

            <textarea autocomplete="off" class="form-control" (input)="onInput()" formControlName="strText"
                [ngStyle]="getStylesObject()" [placeholder]="str_Placeholder">

        </textarea>

        </ng-container>

        <!-- "INPUT" انتخاب حالت دریافت آدرس -->

        <ng-template #isInput>

            <input autocomplete="off" class="form-control" (input)="onInput()" formControlName="strText"
                [ngStyle]="getStylesObject()" [placeholder]="str_Placeholder" />

        </ng-template>

        <!-- انتخاب حالت نمایش دکمه نقشه -->

        <ng-container *ngIf="isLocationBtn">

            <button class="btn btn-warning rounded" (click)="openMap()">

                <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

            </button>

        </ng-container>

    </div>


</ng-template>

<!-- نقشه -->

<div class="modal fade" id="map_Modal">

    <div class="modal-dialog modal-fullscreen">

        <div class="modal-content" style="direction: rtl;">

            <div class="modal-header">

                <h4 class="modal-title" id="exampleModalLabel"> {{ isDrawRoute ? 'مسیر انتخابی سفر شما' : isShowFooter ? 'انتخاب آدرس' : 'مشاهده موقعیت' }} </h4>

                <button type="button" class="btn-close m-0" data-bs-dismiss="modal" aria-label="Close"  (click)="submitAddress()"></button>

            </div>

            <div [formGroup]="mdl_Map" class="modal-body">

                <div class="w-100 pb-2 position-relative">

                    <input class="form-control" formControlName="strText_Toolbar" placeholder="آدرس خود را جستجو کنید..." (keyup.enter)="getLatLong()">

                    <div *ngIf="!mdl_Map.get('strText_Toolbar')?.disabled" class="position-absolute" style="top: 3px;left: 3px;">

                        <i class="fa fa-search bg-primary rounded text-white py-2 px-3 pointer" (click)="getLatLong()"></i>

                    </div>

                </div>

                <div id="map_Container"> </div>

            </div>

            <div *ngIf="isShowFooter" class="modal-footer d-flex justify-content-start">

                <!-- تایید آدرس -->

                <ng-container *ngIf="!isDrawRoute">

                    <button [disabled]="mdl_Map.get('latitude')?.value != '' ? false : true " class="btn btn-success"

                    (click)="submitAddress()">

                    &nbsp; &nbsp; تایید آدرس &nbsp; &nbsp;

                </button>

                </ng-container>

                <!-- بستن -->

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal" (click)="submitAddress()">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>